import React from "react";

const CLIENTS = [
    "Armani Beauty",
    "Valentino Beauty",
    "ICI Formation",
    "Fédération Française de Tennis",
    "ClickandBoat",
    "Colisée",
    "Dentego",
    "Médecins Sans Frontières",
];

const MARKETS = ["France", "Italie", "Espagne", "Allemagne", "Belgique", "Suisse"];

export default function Clients() {
    return (
        <section
            id="clients"
            data-testid="clients-section"
            className="relative py-28 md:py-36 border-t border-[#e8e4dd] bg-white"
        >
            <div className="max-w-[1400px] mx-auto px-5 md:px-10">
                <div className="mb-16 max-w-3xl">
                    <p className="label-eyebrow mb-5">— 04 / Ils m'ont fait confiance</p>
                    <h2
                        className="font-serif text-5xl md:text-6xl tracking-tight text-[#0e0e0c]"
                        style={{ fontWeight: 400 }}
                    >
                        Des marques exigeantes,{" "}
                        <span className="italic-serif">une même rigueur.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 border-l border-t border-[#e8e4dd]">
                    {CLIENTS.map((c, i) => (
                        <div
                            key={c}
                            data-testid={`client-${i}`}
                            className="border-r border-b border-[#e8e4dd] py-12 px-6 flex items-center justify-center min-h-[140px] hover:bg-[#fbfaf7] transition-colors group"
                        >
                            <span className="font-serif text-xl md:text-2xl text-[#0e0e0c] text-center"
                                style={{ fontWeight: 400 }}>
                                {c}
                            </span>
                        </div>
                    ))}
                </div>

                <div className="mt-16 overflow-hidden border-y border-[#e8e4dd] py-7">
                    <div
                        className="flex gap-14 marquee-track whitespace-nowrap"
                        data-testid="markets-marquee"
                    >
                        {[...MARKETS, ...MARKETS, ...MARKETS, ...MARKETS].map(
                            (m, i) => (
                                <span
                                    key={i}
                                    className="font-serif italic text-3xl md:text-4xl text-[#0e0e0c] flex items-center gap-14"
                                    style={{ fontWeight: 400 }}
                                >
                                    {m}
                                    <span className="text-[#b08d57] not-italic">✦</span>
                                </span>
                            )
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}
